import type { ApiScanVideoSubmission } from '@kaiizen/kai-pro-api';

export const formatVideoFileSize = (sizeBytes: number) => {
  if (sizeBytes < 1024) return `${sizeBytes} B`;
  if (sizeBytes < 1024 * 1024) return `${(sizeBytes / 1024).toFixed(1)} KB`;
  if (sizeBytes < 1024 * 1024 * 1024) return `${(sizeBytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(sizeBytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
};

export const formatVideoTimestamp = (value: string | Date) => {
  const date = value instanceof Date ? value : new Date(value);
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(date);
};

/** "M:SS" readout for video playback position and duration. */
export const formatPlaybackTimeSeconds = (seconds: number): string => {
  const wholeSeconds = Math.max(0, Math.floor(seconds));
  return `${Math.floor(wholeSeconds / 60)}:${`${wholeSeconds % 60}`.padStart(2, '0')}`;
};

export const getSubmissionSubtitle = (submission: ApiScanVideoSubmission) => {
  const uploader = submission.userName?.trim() || 'Unknown uploader';
  return `${uploader} · ${formatVideoTimestamp(submission.createdAt)} · ${formatVideoFileSize(submission.sizeBytes)}`;
};
